/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { querySubweb } from 'services/requests'

const initialState = {
  name: null,
  pages: [],
  pagesQuickAccess: [],
  error: null,
  isLoading: true,
  currentPage: 1,
  totalRecords: 1,
  search: '',
  isLoadingTable: true,
}

// Slice
// automatically generates action creators
// and action types that correspond to the reducers and state
// https://redux-toolkit.js.org/api/createSlice
const subwebSlice = createSlice({
  name: 'subweb',
  initialState,
  reducers: {
    getSubwebPagesStart(state, action) {
      const {
        isLoading, isLoadingTable, currentPage, search
      } = action.payload
      state.isLoading = isLoading
      state.isLoadingTable = isLoadingTable
      state.currentPage = currentPage
      state.search = search
    },
    getSubwebPagesSuccess(state, action) {
      state.name = action.payload.name
      state.pages = action.payload.pages
      state.currentPage = action.payload.currentPage
      state.totalRecords = action.payload.totalRecords
      state.error = null
      state.isLoading = false
      state.isLoadingTable = false
    },
    getSubwebPagesFailure(state) {
      state.name = null
      state.pages = []
      state.pagesQuickAccess = []
      state.error = null
      state.isLoading = false
      state.isLoadingTable = false
    },
    setSubwebPagesQuickAccess(state, action) {
      state.pagesQuickAccess = action.payload
      state.isLoadingTable = false
    },
  }
})

// actions
export const {
  getSubwebPagesStart,
  getSubwebPagesSuccess,
  getSubwebPagesFailure,
  setSubwebPagesQuickAccess,
} = subwebSlice.actions

// thunks
export const fetchSubweb = (
  { subweb, search = '', page = 1 }
) => async (dispatch, getState) => {
  const { subweb: subwebState } = getState()
  if (!subweb) {
    dispatch(getSubwebPagesFailure('Missing subweb parameter'))
    return;
  }
  try {
    const isLoading = (
      page === 1
      && search === ''
      && subweb !== subwebState.name
    )
    dispatch(getSubwebPagesStart({
      isLoading,
      isLoadingTable: true,
      currentPage: page,
      search,
    }))
    const response = await querySubweb(
      subweb,
      {
        params: {
          currentPage: page,
          search,
        }
      },
      true
    )

    const { data: { data: pages, pagination: { currentPage, totalRecords } } } = response
    // get quick access pages from first page results
    if (search === '' && currentPage === 1) {
      const maxQuickAccess = 4
      const pagesQuickAccess = pages.slice(0, maxQuickAccess)
      dispatch(setSubwebPagesQuickAccess(pagesQuickAccess))
    }
    dispatch(getSubwebPagesSuccess({
      pages, currentPage, name: subweb, totalRecords
    }))
  } catch (err) {
    // error wasn't due to cancelling
    dispatch(getSubwebPagesFailure(err.message.toString()))
  }
}

export default subwebSlice.reducer
